import "@ifrc-go/ui/index.css";
import "./locales/i18n";

import { Suspense } from "react";
import ReactDOM from "react-dom";

import App from "./app";

import "./styles/go-reset.module.css";
import styles from './styles.module.css';

ReactDOM.render(
  <Suspense
    fallback={(
      <div className={styles.fallbackElement}>
        Survey Designer Loading...
      </div>
    )}
  >
    <App />
  </Suspense>,
  document.getElementById("root")
);
